export const DotBackground = {
  content: '""',
  inset: 0,
  backgroundImage:
    'radial-gradient(circle, rgba(0,0,0,0.15) 1px, transparent 1px)',
  backgroundSize: '24px 24px',
  position: 'absolute',
} as const;
